export const tests = [
  {
    'uuid': 'f39f5f4a-1aee-470a-8a39-97b16f326db5',
    'created_at': 1631182293,
    'user_uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    'type': 'bp',
    'name': 'test1',
    'app_version': 1,
    'product_type': 'EBM1',
    'tested_at': 1636443276,
    'description': 'SampleTest',
    'duration': 20000,
    'meta': {
      'subtype': '1-lead'
    },
    'tags': ['salam', 'tag1']
  },
  {
    'uuid': 'f39f5f4a-1aee-470a-8a39-97b16f326db4',
    'created_at': 1631181293,
    'user_uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    'type': 'bp',
    'name': 'test1',
    'app_version': 1,
    'product_type': 'EBM1',
    'tested_at': 1636443277,
    'description': 'SampleTest',
    'duration': 20000,
    'meta': {
      'subtype': '1-lead'
    },
    'tags': ['salam', 'tag2']
  },
  {
    'uuid': 'f35f5f4a-1aee-470a-8a39-97b16f326db4',
    'created_at': 1632250184,
    'user_uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    'type': 'ecg',
    'name': 'testEcg',
    'app_version': 1,
    'product_type': 'EBM1',
    'tested_at': 1636443218,
    'description': 'SampleTest',
    'duration': 20000,
    'meta': null,
    'tags': ['tag3']
  },
  {
    'uuid': 'f35f5f4a-1aee-470a-8a39-97b16f326db0',
    'created_at': 1632250194,
    'user_uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    'type': 'ecg',
    'name': 'testEcg2',
    'app_version': 1,
    'product_type': 'EBM1',
    'tested_at': 1636443291,
    'description': 'SampleTest desc',
    'duration': 20000,
    'meta': null,
    'tags': ['tag3']
  }
]



// WEBPACK FOOTER //
// ./src/_helpers/backend-data/test.js